var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-back"},[_c('a',{staticClass:"header-back-btn",attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.group1.historyBack.apply(null, arguments)}}},[_c('IcArrowLeft',{staticClass:"icn lg"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }